import React from 'react';

const categories = [
  { id: 'all', label: 'Alle', icon: '◈', count: 32 },
  { id: 'konto', label: 'Konto', icon: '◉', count: 8 },
  { id: 'fakturering', label: 'Fakturering', icon: '◎', count: 7 },
  { id: 'bomkalkulator', label: 'Bomkalkulator', icon: '◐', count: 9 },
  { id: 'teknisk', label: 'Teknisk støtte', icon: '◑', count: 8 },
];

const FAQCategoryNav = ({ activeCategory, onCategoryChange }) => {
  return (
    <div style={{
      background: '#0A1220',
      borderBottom: '1px solid rgba(255,255,255,0.06)',
      position: 'sticky', top: 0, zIndex: 40
    }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 5%' }}>
        <div style={{ display: 'flex', gap: '0', overflowX: 'auto', scrollbarWidth: 'none' }}>
          {categories?.map((cat) => (
            <button
              key={cat?.id}
              onClick={() => onCategoryChange(cat?.id)}
              style={{
                padding: '20px 28px',
                background: 'none',
                border: 'none',
                borderBottom: activeCategory === cat?.id ? '3px solid #E8521A' : '3px solid transparent',
                cursor: 'pointer',
                display: 'flex', alignItems: 'center', gap: '10px',
                whiteSpace: 'nowrap',
                transition: 'all 200ms ease'
              }}
            >
              <span style={{
                fontFamily: 'JetBrains Mono, monospace',
                fontSize: '1rem',
                color: activeCategory === cat?.id ? '#E8521A' : 'rgba(138,149,163,0.5)'
              }}>{cat?.icon}</span>
              <span style={{
                fontFamily: 'Syne, sans-serif',
                fontSize: '0.8125rem',
                fontWeight: 700,
                color: activeCategory === cat?.id ? '#EEF0F2' : 'rgba(138,149,163,0.6)',
                letterSpacing: '0.06em',
                textTransform: 'uppercase'
              }}>{cat?.label}</span>
              <span style={{
                fontFamily: 'JetBrains Mono, monospace',
                fontSize: '0.6875rem',
                color: activeCategory === cat?.id ? '#3B6FD4' : 'rgba(138,149,163,0.3)',
                background: activeCategory === cat?.id ? 'rgba(59,111,212,0.1)' : 'rgba(255,255,255,0.03)',
                padding: '2px 7px',
                border: '1px solid',
                borderColor: activeCategory === cat?.id ? 'rgba(59,111,212,0.3)' : 'rgba(255,255,255,0.06)'
              }}>{cat?.count}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQCategoryNav;
